import type { Router } from 'vue-router';

/**
 * Opens the "Chi tiết hợp đồng" PDF viewer page in a new browser tab.
 */
export function openHopDongPdf(
  router: Router,
  idHopDong: number | string | null | undefined
): void {
  if (!idHopDong) return;

  const route = router.resolve({
    name: 'xem-hop-dong',
    params: { id: String(idHopDong) },
  });

  window.open(route.href, '_blank');
}
